module.exports = __webpack_public_path__ + "static/media/print.7bef0d2e.svg";